import type { Home } from '@lmc/ts-common'
import { getNominative } from 'common/utils'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

/** The home's word for a service user, e.g. "Resident" / "Residents". */
export const useServiceUserWords = () => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const nominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home?.preferredPeopleNominative
  )

  return {
    plural: getNominative(
      nominative,
      t(incidentReportsConstants.CASE_V2_SERVICE_USERS)
    ),
    singular: getNominative(
      nominative,
      t(incidentReportsConstants.CASE_V2_VIEW_SERVICE_USER)
    )
  }
}
